import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg404 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 391,
	height: 160,
	fill: "none",
	viewBox: "0 0 391 160",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 203,
			cy: 80,
			r: 80,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "t016mt5o2a",
			width: 160,
			height: 160,
			x: 123,
			y: 0,
			maskUnits: "userSpaceOnUse",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 203,
				cy: 80,
				r: 80,
				fill: "#34ce72"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#t016mt5o2a)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#paint0_linear)",
					d: "M187.063 76h31.874L231 167h-56l12.063-91z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34ce72",
					d: "M175.23 56.034c2.146-13.645 13.681-24.05 27.603-24.034 13.902.017 25.451 10.422 27.652 24.045C252.07 59.441 266.992 66.681 267 75.051c.011 11.602-28.634 20.98-63.98 20.949-35.347-.032-64.009-9.463-64.02-21.064-.008-8.338 14.786-15.528 36.23-18.902z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34ce72",
					fillRule: "evenodd",
					d: "M195.615 139.521c-2.428.216-2.318 1.187-4.305 3.67-.331.54-.221.756 0 1.295.221 1.188.331 2.267.552 3.454 0 .432-.11.54.331.54-.11.324-.331.324 0 .54.331.432.331.54.883.54 1.766 0 1.546.108.442-1.62-.221-.323-.552-2.482-.663-3.454 0-.323.111-.647.332-.863-.111 0-.332-.108-.552-.432.22.216.331.324.552.324.331.648.441 0 .551.108.663.648.332-.54.663-.216.662.648.221-.216.662-.216.552.108.773-.216.552-.863.662-.432 1.214-.864 1.766-1.296 3.422.864 4.968.864 8.831.648 0 1.403.773 3.022.552 4.102-.11.755-.331 2.158-.221 2.59 0 .216.111.108.221.324.221.216-.331 1.079.552 1.187 2.097 0 1.876.216.993-1.511-.331-.432-.22-1.835-.11-2.59 0-.648.331-1.08.662-1.727.442-.972.994-3.239 1.214-4.318.111.54-.551 2.914-.993 4.426.11.539.331.863.331 1.511 0 .863 0 2.159.111 2.59.11.216.22 0 .331.216.22.216-.111 1.188.772 1.08 1.987-.324 1.877-.108.663-1.62-.331-.323-.442-1.619-.552-2.482-.111-1.187.772-2.591.883-3.994 1.876-.108 1.656-2.159 3.201-3.13.773-.54 1.214-1.619 1.435-2.807 1.545.108 2.76-.539 4.526-.324 1.324.108 1.545-1.403.773-2.266-.773-.756-1.215-1.403-1.877-2.051-.11-.756-.442-1.295-1.325-1.619v-.648c.552-.432.773-.971.663-1.619-.331.54-.883.864-1.766.971.22-.323.22-.647.11-.863-.442.54-1.214.756-1.656 1.187-3.201 2.915-3.753 1.943-8.389 2.483-4.636.432-9.824.54-14.24-.432-7.506-1.619-3.974 4.857-5.078 9.715-1.103 1.079-1.103 2.806-.883 3.346 1.877-2.699 1.215-2.699 1.325-3.346.221-.756.331-6.585.662-6.908-.22 1.619-.22 3.346-.11 4.965.11 2.806-1.214 3.67-.662 6.692.11 1.08.11 2.159.11 3.13 0 .54-.11.864.331.864-.221.324-.331.324-.11.648.331.431.331.539.883.539 1.876 0 1.656.216.662-1.511-.441-.647-.331-2.698 0-3.67.221-.863 1.546-2.374 2.429-3.67.883-1.187 1.435-1.727 2.98-1.619zm22.408-8.743c-.11 0 .221 0 .221.108-.11.324.331.324.331.324.111-.108.221.108.221.108-.11-.324-.552-.648-.773-.54z",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34ce72",
					d: "M158 38l1.506 4.494L164 44l-4.494 1.506L158 50l-1.506-4.494L152 44l4.494-1.506L158 38z",
					opacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34ce72",
					d: "M233 13l2.008 5.992L241 21l-5.992 2.008L233 29l-2.008-5.992L225 21l5.992-2.008L233 13z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34ce72",
					d: "M252 44l1.004 2.996L256 48l-2.996 1.004L252 52l-1.004-2.996L248 48l2.996-1.004L252 44z",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#34ce72",
					d: "M154 112l1.004 2.996L158 116l-2.996 1.004L154 120l-1.004-2.996L150 116l2.996-1.004L154 112zM240 105l1.004 2.996L244 109l-2.996 1.004L240 113l-1.004-2.996L236 109l2.996-1.004L240 105z",
					opacity: .5
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M66.528 127.352H0V97.328L70.2 4.016h47.52v84.672h20.52v38.664h-20.52V155H66.528v-27.648zm7.56-38.664V63.632L55.296 88.688h18.792zM318.528 127.352H252V97.328l70.2-93.312h47.52v84.672h20.52v38.664h-20.52V155h-51.192v-27.648zm7.56-38.664V63.632l-18.792 25.056h18.792z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear",
			x1: 203,
			x2: 203,
			y1: 76,
			y2: 167,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#34ce72",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#34ce72"
			})]
		}) })
	]
});
export default Svg404;
